import { useModernFamlyContext } from '@famly/mf_system_provider';
/**
 * Gets a translated string by its key
 */
export const useTranslation = (translationKey, ...values) => {
    const { locale } = useModernFamlyContext();
    return buildMessage(locales[locale][translationKey], ...values);
};
export const danish = {
    'DropdownButton.close': 'Luk',
    'FormControl.clear': 'Ryd',
    'Toast.errorCode': 'Fejlkode',
    'DropdownPill.more': 'og {0} mere',
    'DropdownPill.selected': '{0} valgte',
    'PlaygroundBox.enabled': 'Aktiveret',
    'PlaygroundBox.disabled': 'Diaktiveret',
    'PlaygroundBox.optIn': 'Opt in',
    'PlaygroundBox.optOut': 'Opt out',
    'PlaygroundBox.readMore': 'Read more',
    'PlaygroundBox.readLess': 'Read less',
    'FilterAutocomplete.selected': '{0} valgte',
    'FilterAutocomplete.clearAll': 'Ryd alle',
    'FilterAutocomplete.selectAll': 'Vælg alle',
    'FilterAutocomplete.emptyResults': 'Ingen der matcher',
    'FilterAutocomplete.placeholder': 'Søg',
    'FavoriteButton.addFavorite': 'Tilføj favorit',
    'FavoriteButton.removeFavorite': 'Fjern favorit',
    'BulkActionBar.selectedCount': '{0} valgt',
    'BulkActionBar.deselectAll': 'Fravælg alle',
    'ListDrawer.defaultCloseButtonText': 'Luk',
    'MobileListRow.more': 'Mere',
    'Dialog.cancel': 'Fortryd',
    'Dialog.confirm': 'Bekræft',
    'Modal.cancel': 'Fortryd',
    'Modal.confirm': 'Bekræft',
    'WeekPicker.previousWeek': 'Forrige uge',
    'WeekPicker.nextWeek': 'Næste uge',
    'WeekPicker.weekOf': 'Uge med:',
};
export const english = {
    'DropdownButton.close': 'Close',
    'FormControl.clear': 'Clear',
    'Toast.errorCode': 'Error code',
    'DropdownPill.more': 'and {0} more',
    'DropdownPill.selected': '{0} selected',
    'PlaygroundBox.enabled': 'Enabled',
    'PlaygroundBox.disabled': 'Disabled',
    'PlaygroundBox.optIn': 'Opt in',
    'PlaygroundBox.optOut': 'Opt out',
    'PlaygroundBox.readMore': 'Read more',
    'PlaygroundBox.readLess': 'Read less',
    'FilterAutocomplete.selected': '{0} selected',
    'FilterAutocomplete.clearAll': 'Clear all',
    'FilterAutocomplete.selectAll': 'Select all',
    'FilterAutocomplete.emptyResults': 'No items matching',
    'FilterAutocomplete.placeholder': 'Search',
    'FavoriteButton.addFavorite': 'Add favorite',
    'FavoriteButton.removeFavorite': 'Remove favorite',
    'BulkActionBar.selectedCount': '{0} selected',
    'BulkActionBar.deselectAll': 'Deselect all',
    'ListDrawer.defaultCloseButtonText': 'Close',
    'MobileListRow.more': 'More',
    'Dialog.cancel': 'Cancel',
    'Dialog.confirm': 'Confirm',
    'Modal.cancel': 'Cancel',
    'Modal.confirm': 'Confirm',
    'WeekPicker.previousWeek': 'Previous week',
    'WeekPicker.nextWeek': 'Next week',
    'WeekPicker.weekOf': 'Week of:',
};
export const german = {
    'DropdownButton.close': 'Schließen',
    'FormControl.clear': 'Löschen',
    'Toast.errorCode': 'Fehlercode',
    'DropdownPill.more': 'und {0} mehr',
    'DropdownPill.selected': '{0} ausgewählt',
    'PlaygroundBox.enabled': 'Aktiviert',
    'PlaygroundBox.disabled': 'Deaktiviert',
    'PlaygroundBox.optIn': 'Opt in',
    'PlaygroundBox.optOut': 'Opt out',
    'PlaygroundBox.readMore': 'Read more',
    'PlaygroundBox.readLess': 'Read less',
    'FilterAutocomplete.selected': '{0} ausgewählt',
    'FilterAutocomplete.clearAll': 'Alle löschen',
    'FilterAutocomplete.selectAll': 'Alle auswählen',
    'FilterAutocomplete.emptyResults': 'Keine passenden Einträge',
    'FilterAutocomplete.placeholder': 'Suchen',
    'FavoriteButton.addFavorite': 'Favorit hinzufügen',
    'FavoriteButton.removeFavorite': 'Favorit entfernen',
    'BulkActionBar.selectedCount': '{0} ausgewählt',
    'BulkActionBar.deselectAll': 'Alle abwählen',
    'ListDrawer.defaultCloseButtonText': 'Schließen',
    'MobileListRow.more': 'Mehr',
    'Dialog.cancel': 'Abbrechen',
    'Dialog.confirm': 'Bestätigen',
    'Modal.cancel': 'Abbrechen',
    'Modal.confirm': 'Bestätigen',
    'WeekPicker.previousWeek': 'Vorherige Woche',
    'WeekPicker.nextWeek': 'Nächste Woche',
    'WeekPicker.weekOf': 'Woche vom:',
};
export const spanish = {
    'DropdownButton.close': 'Cerrar',
    'FormControl.clear': 'Claro',
    'Toast.errorCode': 'Código de error',
    'DropdownPill.more': 'y {0} más',
    'DropdownPill.selected': '{0} seleccionados',
    'PlaygroundBox.enabled': 'Activado',
    'PlaygroundBox.disabled': 'Desactivado',
    'PlaygroundBox.optIn': 'Opt in',
    'PlaygroundBox.optOut': 'Opt out',
    'PlaygroundBox.readMore': 'Read more',
    'PlaygroundBox.readLess': 'Read less',
    'FilterAutocomplete.selected': '{0} seleccionados',
    'FilterAutocomplete.clearAll': 'Borrar todo',
    'FilterAutocomplete.selectAll': 'Seleccionar todo',
    'FilterAutocomplete.emptyResults': 'No items matching',
    'FilterAutocomplete.placeholder': 'Search',
    'FavoriteButton.addFavorite': 'Añadir favorito',
    'FavoriteButton.removeFavorite': 'Eliminar favorito',
    'BulkActionBar.selectedCount': '{0} seleccionados',
    'BulkActionBar.deselectAll': 'Deseleccionar todo',
    'ListDrawer.defaultCloseButtonText': 'Cerrar',
    'MobileListRow.more': 'Más',
    'Dialog.cancel': 'Cancelar',
    'Dialog.confirm': 'Confirmar',
    'Modal.cancel': 'Cancelar',
    'Modal.confirm': 'Confirmar',
    'WeekPicker.previousWeek': 'Semana anterior',
    'WeekPicker.nextWeek': 'Siguiente semana',
    'WeekPicker.weekOf': 'Semana del:',
};
export const norwegian = {
    'DropdownButton.close': 'Lukk',
    'FormControl.clear': 'Klar',
    'Toast.errorCode': 'Feilkode',
    'DropdownPill.more': 'og {0} til',
    'DropdownPill.selected': '{0} valgt',
    'PlaygroundBox.enabled': 'Aktivert',
    'PlaygroundBox.disabled': 'Deaktivert',
    'PlaygroundBox.optIn': 'Opt in',
    'PlaygroundBox.optOut': 'Opt out',
    'PlaygroundBox.readMore': 'Read more',
    'PlaygroundBox.readLess': 'Read less',
    'FilterAutocomplete.selected': '{0} valgt',
    'FilterAutocomplete.clearAll': 'Fjern alle',
    'FilterAutocomplete.selectAll': 'Velg alle',
    'FilterAutocomplete.emptyResults': 'No items matching',
    'FilterAutocomplete.placeholder': 'Search',
    'FavoriteButton.addFavorite': 'Legg til favoritt',
    'FavoriteButton.removeFavorite': 'Fjern favoritt',
    'BulkActionBar.selectedCount': '{0} valgt',
    'BulkActionBar.deselectAll': 'Fjern alle',
    'ListDrawer.defaultCloseButtonText': 'Lukk',
    'MobileListRow.more': 'Mer',
    'Dialog.cancel': 'Avbryt',
    'Dialog.confirm': 'Bekrefte',
    'Modal.cancel': 'Avbryt',
    'Modal.confirm': 'Bekrefte',
    'WeekPicker.previousWeek': 'Forrige uke',
    'WeekPicker.nextWeek': 'Neste uke',
    'WeekPicker.weekOf': 'Uke start:',
};
export const dutch = {
    'DropdownButton.close': 'Sluiten',
    'FormControl.clear': 'Wissen',
    'Toast.errorCode': 'Foutcode',
    'DropdownPill.more': 'en {0} meer',
    'DropdownPill.selected': '{0} geselecteerd',
    'PlaygroundBox.enabled': 'Ingeschakeld',
    'PlaygroundBox.disabled': 'Uitgeschakeld',
    'PlaygroundBox.optIn': 'Opt in',
    'PlaygroundBox.optOut': 'Opt out',
    'PlaygroundBox.readMore': 'Read more',
    'PlaygroundBox.readLess': 'Read less',
    'FilterAutocomplete.selected': '{0} geselecteerd',
    'FilterAutocomplete.clearAll': 'Alles wissen',
    'FilterAutocomplete.selectAll': 'Alles selecteren',
    'FilterAutocomplete.emptyResults': 'Geen overeenkomende items',
    'FilterAutocomplete.placeholder': 'Zoeken',
    'FavoriteButton.addFavorite': 'Favoriet toevoegen',
    'FavoriteButton.removeFavorite': 'Favoriet verwijderen',
    'BulkActionBar.selectedCount': '{0} geselecteerd',
    'BulkActionBar.deselectAll': 'Alles deselecteren',
    'ListDrawer.defaultCloseButtonText': 'Sluiten',
    'MobileListRow.more': 'Meer',
    'Dialog.cancel': 'Annuleren',
    'Dialog.confirm': 'Bevestigen',
    'Modal.cancel': 'Annuleren',
    'Modal.confirm': 'Bevestigen',
    'WeekPicker.previousWeek': 'Vorige week',
    'WeekPicker.nextWeek': 'Volgende week',
    'WeekPicker.weekOf': 'Week van:',
};
const locales = {
    daDK: danish,
    enUS: english,
    deDE: german,
    deCH: german,
    nbNO: norwegian,
    esES: spanish,
    esUS: spanish,
    enGB: english,
    nlNL: dutch,
};
const buildMessage = (str, ...values) => str.replace(/{(\d)}/g, (_, firstCapturedGroup) => values[Number(firstCapturedGroup)]);
